import { Image, Input, Table } from 'antd'
import React, { useState } from 'react'
import { StaticImages } from '../../../Utils/StaticImages'
import CustomButton from '../../../Components/CustomButton';
import DeleteModal from '../../../Modals/DeleteModal';
import { useDynamicMutationMutation, useDynamicQueryQuery } from '../../../redux/service/apiSlice';
import { Endpoints } from '../../../Utils/EndPoints';
import { QueryKeys } from '../../../Utils/RTKKeys';
import { toast } from 'react-toastify';
import debounce from 'lodash.debounce'; // Import lodash.debounce for debouncing
import Loader from '../../../Components/Loader';
import ReplyModal from '../../../Modals/ReplyModal';


function ContactUs() {


    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteType, setDeleteType] = useState('single'); // Track delete type
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [searchText, setSearchText] = React.useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]); // Track selected row IDs
    const [statusMutation, { isLoading: statusUpdateLoading }] = useDynamicMutationMutation();

    const [replyContactMutation, { isLoading: replyload }] = useDynamicMutationMutation();

    const [openReply, setOpenReply] = useState();

    const [selectedReply, setselectedReply] = useState();

    //for add data in replymodal
    const [replyData, setReplyData] = useState({ email: '', message: '' });

    const [pagination, setPagination] = React.useState({
        current: 1,
        pageSize: 10,
        total: 10,
    });



    const handleDeleteClick = (contact = null) => {
        setDeleteType('single');
        setSelectedUser(contact); // Set the selected single user
        setOpenDeleteModal(true);

    };

    const handleDeleteAllClick = () => {
        setDeleteType('multiple');
        setOpenDeleteModal(true); // Open the delete confirmation modal
    };



    // listing get api
    const { data: listData, isLoading } = useDynamicQueryQuery({
        endpoint: `${Endpoints.NON_AUTH.CONTACT_US}?${new URLSearchParams(
            searchText
                ? { search_key: searchText, page: pagination.current, limit: pagination.pageSize }
                : { page: pagination.current, limit: pagination.pageSize }
        ).toString()}`,
        params: {},
        key: QueryKeys.CONTACT_US,
    }, { skip: false, refetchOnMountOrArgChange: true }
    )


    const tableData = listData?.data


    //storing and updating pagination

    React.useEffect(() => {
        if (tableData) {
            setPagination({
                ...pagination,
                total: tableData.totalCount, // Update total pages from API response
            });
        }
    }, [listData]);




    const handlePaginationChange = (page, pageSize) => {
        setPagination((prev) => ({
            ...prev,
            current: page,
            pageSize,
        }));
    };




    const handleSearch = (value) => {
        console.log('value', value);
        setSearchText(value);
    };

    const debouncedSearch = debounce(handleSearch, 500);


    //handle delete user

    const handleDeleteAllContact = async () => {
        const contactIds = deleteType === 'single' ? [selectedUser?._id] : selectedRows.map((contact) => contact._id);

        try {
            const requestData = {
                endpoint: Endpoints.NON_AUTH.DELETE_CONTACT, // Replace with your DELETE endpoint
                method: 'DELETE',
                body: {
                    contact_id: contactIds, // Array of user IDs
                },
                key: QueryKeys.CONTACT_US,
            };

            const { data, error } = await statusMutation(requestData);

            if (data) {
                toast.success('Contact(s) deleted successfully!');
                setSelectedRowKeys([]); // Clear selected rows
                setSelectedRows([]); // Clear selected rows data
                setOpenDeleteModal(false); // Close the modal
            } else {
                toast.error(`Failed to delete Contact(s): ${error?.data?.message || 'Unknown error'}`);
            }
        } catch (err) {
            toast.error(`An error occurred: ${err.message || 'Unknown error'}`);
        }
    };



    const handleReplyClick = (contact) => {
        setReplyData({
            email: contact.email,
            message: '', // Ensure the message is empty when replying
            _id: contact._id,
        });
        setOpenReply(true);
    };




    const handleReplySubmit = async () => {
        try {

            // Close the modal before starting the API call

            setOpenReply(false);

            const payload = {
                html: replyData.message,
                contact_id: replyData._id
            }
            const requestData = {
                endpoint: Endpoints.NON_AUTH.REPLY_CONTACT, // Replace with your DELETE endpoint
                method: 'POST',
                body: payload,
                key: QueryKeys.CONTACT_US,
            };
            setselectedReply(replyData._id);

            const { data, error } = await replyContactMutation(requestData);

            if (data) {
                toast.success("Reply sent successfully!");
                setOpenReply(false);  // Close the modal after successful reply
                setselectedReply(null);
            } else {
                toast.error(`Failed to send reply: ${error?.data?.message || 'Unknown error'}`);
                setselectedReply(null);

            }
        }
        catch (err) {
            toast.error(`An error occurred: ${err.message || 'Unknown error'}`);
            setselectedReply(null);

        }
    }


    const columns = [
        {
            title: 'Sr.No',
            dataIndex: 'SrNo',
            key: 'number',
            render: (text, record, index) => {
                return pagination.pageSize * (pagination.current - 1) + index + 1;
            }

        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },

        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',

        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'message'
        },
        {
            title: 'Action',
            dataIndex: 'action',
            align: 'center',
            key: 'action',
            render: (action, items) => (
                <div className="flex gap-2 justify-center">
                    {/* Conditionally hide the Delete button based on selection */}
                    {!selectedRows.length && (
                        <CustomButton
                            title="Delete"
                            type="text"
                            className="rounded-10 bg-red-200 text-white-100 w-[8rem]"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteClick(items); // Delete action
                            }}
                        />
                    )}
                    {/* Reply button is always visible */}
                    <CustomButton
                        title="Reply"
                        type="text"
                        // loading={replyload}
                        loading={selectedReply === items._id ? replyload : false}

                        className="rounded-10 bg-green-600 text-white-100 w-[8rem]"
                        onClick={() => handleReplyClick(items)}
                    />
                </div>
            ),
        },


    ];


    const rowSelection = {

        selectedRowKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setSelectedRowKeys(newSelectedRowKeys);
            setSelectedRows(newSelectedRows);
        },
    };

    // Calculate the total number of pages
    const totalPages = Math.ceil(pagination.total / pagination.pageSize);

    // Determine if all rows are selected
    const isAllRowsSelected = selectedRows.length === tableData?.result?.length;



    return (

        <div className='p-6 px-1'>
            <div className="flex justify-between  items-center flex-wrap ">
                <p className="text-h2 font-bold"> Contact Us</p>
                <div className="flex justify-between  items-center gap-4 ">
                    {selectedRows.length > 0 && (
                        <CustomButton
                            onClick={handleDeleteAllClick}
                            loading={statusUpdateLoading}
                            className='rounded-10 bg-red-200 text-white-100 w-[6rem] px-8 sm:w-[8rem]'
                            title={isAllRowsSelected ? 'Delete All' : `Delete ${selectedRows.length} `}
                        />
                    )}
                    <Input placeholder="Search..." size='large'
                        onChange={(e) => debouncedSearch(e.target.value)}  // Trigger the debounced search on input change
                        prefix={<Image src={StaticImages.Arrow.Search} alt='search_Icon' preview={false} draggable={false} />}
                        className="commonInput w-[110px] sm:w-[220px]  !important "
                    />
                </div>
            </div>
            <div className="mt-6">
                {
                    isLoading ? <Loader />
                        :
                        <>
                            <Table
                                rowSelection={rowSelection}
                                scroll={{ x: 300 }}
                                rowKey={(record) => record?._id}
                                columns={columns}
                                dataSource={tableData?.result}

                                pagination={
                                    totalPages > 1 && pagination.total > 10
                                        ? {
                                            current: pagination.current,
                                            total: pagination.total,
                                            pageSize: pagination.pageSize,
                                            onChange: handlePaginationChange, // Handle page changes
                                            showSizeChanger: false, // Disable the dropdown
                                            itemRender: (current, type, originalElement) => {
                                                if (type === 'prev') {
                                                    return <a className="text-black-100">PREV</a>;
                                                }
                                                if (type === 'next') {
                                                    return <a className="text-black-100">NEXT</a>;
                                                }
                                                return originalElement;
                                            },
                                            className: 'pr-[50px] text-black-100 cursorPointer',
                                        }
                                        : false}
                                className="rounded-10 overflow-hidden shadow-custom text-black-100 cursorPointer"
                            />
                        </>
                }
            </div>

            <DeleteModal openDeleteModal={openDeleteModal} setOpenDeleteModal={setOpenDeleteModal}
                selectedUser={selectedUser} onDelete={handleDeleteAllContact} title1='Delete Contact'
                title2="Are you sure you want to Delete this Contact?"
            />

            <ReplyModal
                openReply={openReply}
                setOpenReply={setOpenReply}
                replyData={replyData}
                onSubmit={handleReplySubmit}
                setReplyData={setReplyData}

            />

        </div>
    )
}

export default ContactUs
